import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ChallengesMilestoneDataService {
  private challengeDetails: any = null;
  private milestoneConfig: any = null;
  private singleMilestoneConfig: any = null;

  // Setter methods
  setChallengeDetails(data: any) {
    this.challengeDetails = data;
  }

  setMilestoneConfig(data: any) {
    this.milestoneConfig = data;
  }

  setSingleMilestoneConfig(data: any) {
    this.singleMilestoneConfig = data;
  }

  // Getter methods
  getChallengeDetails() {
    return this.challengeDetails;
  }

  getMilestoneConfig() {
    if (
      !this.milestoneConfig ||
      typeof this.milestoneConfig !== "object" ||
      Object.keys(this.milestoneConfig).length === 0
    ) {
      return []; // Set it to an empty array if it's invalid
    } else {
      return this.milestoneConfig;
    }
  }

  getSingleMilestoneConfig() {
    return this.singleMilestoneConfig;
  }

  resetAllData() {
    this.challengeDetails = null;
    this.milestoneConfig = null;
    this.singleMilestoneConfig = null;
  }
}
